import React, { memo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from './assets/styles/form.styles'
import { ValidatorForm } from 'react-material-ui-form-validator'
import TextInput from './TextInput'
import { FormConfiguration } from '../configuration'
import Selectors from './Selectors'
import CheckBoxes from './CheckBoxes'
import Button from '@material-ui/core/Button'
import { useAppSelector } from '../app/hooks/reduxHooks'
import { useMediaQuery } from '@material-ui/core'

const useStyles = makeStyles(styles)

function Form() {
    const classes = useStyles()
    const firstCheckBoxChecked = useAppSelector(state => state.form.firstCheckBox)
    const isMobile = useMediaQuery('(max-width: 760px)')
    const textAreaLabel = isMobile ? 'Il tuo messagio' : 'Messagio'
    const textAreaPlaceHolder = isMobile ? 'Inserisci il tuo messagio' : 'Il tuo messagio'
    return (
        <div seconds={3} >
            <ValidatorForm noValidate onSubmit={() => console.log('form submit')} className={classes.root} >
                <span className={classes.doubleRow} >
                    <TextInput
                        validate
                        placeholder='Nome'
                        validationType='isText'
                        validationMessage='Si prega di fornire un nome corretto'
                        name='nome'
                        label='Nome'
                    />
                    <TextInput
                        validate
                        placeholder='Cognome'
                        validationType='isText'
                        validationMessage='Si prega di fornire un cognome corretto'
                        name='cognome'
                        label='Cognome'
                    />
                </span>
                <span className={classes.doubleRow} >
                    <TextInput
                        name='professione'
                        label='Professione'
                        placeholder='Professione'
                    />
                    <TextInput
                        validate
                        validationType='isEmail'
                        validationMessage='Si prega di fornire un email corretto'
                        name='email'
                        label='Email'
                        placeholder='Email'
                    />
                </span>
                <Selectors />
                <span className={classes.textArea} >
                    <TextInput
                        name='messagio'
                        label={textAreaLabel}
                        placeholder={textAreaPlaceHolder}
                        multiLine
                        fullWidth
                    />
                </span>
                <p className={classes.campi} >* Campi obbligatori</p>
                <p className={classes.p} >Ho letto e compreso l'
                    <a
                        className={classes.a}
                        href={FormConfiguration.infoSulPrivacy} >
                        informativa sulla privacy
                    </a>
                </p>
                <CheckBoxes />
                <Button disabled={!firstCheckBoxChecked} type='submit' className={classes.submitBtn} >
                    Ricevi informazioni
                </Button>
            </ValidatorForm>
        </div>
    )
}

export default memo(Form)